import { ApiClientBase } from "../framework/services/api-client-base";
import { isThisLocalhost } from "../framework/utils";
import { localhostApi } from "./localhost-api";

class PublicApiClientClass extends ApiClientBase {
    constructor() {
        super();

        this.host = isThisLocalhost() ? localhostApi : window.location.origin;
        this.host = this.host + '/api';
    }

    protected acquireToken(): Promise<string> {
        return Promise.resolve('');
    }
}

export const PublicApiClient = new PublicApiClientClass();